/**
 * Wrapper components for Medication Administration Form
 * These components pass the correct type prop (1 for medication, 0 for non-medication)
 */

import React from 'react';
import MedicationForm from './medication-form';

// Medication (type = 1)
export const MedicationAdd = () => <MedicationForm type={1} />;
export const MedicationEdit = () => <MedicationForm type={1} />;

// Non-Medication (type = 0)
export const NonMedicationAdd = () => <MedicationForm type={0} />;
export const NonMedicationEdit = () => <MedicationForm type={0} />;

// Medication Logs (type = 1)
export const MedicationLogsView = () => {
  const MedicationLogs = require('./medication-logs').default;
  return <MedicationLogs type={1} />;
};

// Non-Medication Logs (type = 0)
export const NonMedicationLogsView = () => {
  const MedicationLogs = require('./medication-logs').default;
  return <MedicationLogs type={0} />;
};